// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-gallery-modal',
    // #endregion
    // #region Mixins
    mixins: [host.mixins.modal],
    // #endregion
    // #region Properties
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        selectedImage: {
            type: Object,
            required: false,
            default: {}
        },
        images: {
            type: Array,
            required: false,
            default: []
        },
    },
    data: () => ({
        isLoading: false,
        isZoomed: false,
        currentImage: {},
    }),
    // #endregion
    // #region Constructor
    created() {
        this.currentImage = (this.selectedImage ?? {});
    },
    // #endregion
    // #region Core
    methods: {
        isActiveImage(image) {
            return image.name === this.currentImage?.name;
        },
        OnSelect(event, image) {
            this.currentImage = image;
        },
        imgMouseEntry(event) {
            //Element
            let tElement = event.target;
            //Style
            if (this.isZoomed) {
                tElement.classList.remove("zoom-in");
                tElement.classList.add("normal-zoom");
            }
            else {
                tElement.classList.remove("normal-zoom");
                tElement.classList.add("zoom-in");
            }
            //Zoom
            this.isZoomed = !this.isZoomed;
        },
        //https://stackoverflow.com/questions/51256570/move-img-with-mousemove/51256755
        imgMouseMove(event) {
            //Element
            var tTarget = event.target;
            // This gives you the position of the image on the page
            var bbox = tTarget.getBoundingClientRect();
            // Then we measure how far into the image the mouse is in both x and y directions
            var mouseX = event.clientX - bbox.left;
            var mouseY = event.clientY - bbox.top;
            // Then work out how far through the image as a percentage the mouse is
            var xPercent = (mouseX / bbox.width) * 100;
            var yPercent = (mouseY / bbox.height) * 100;
            tTarget.style.setProperty("transform-origin", (xPercent + '% ' + yPercent + '%'));
        },
        imgMouseLeave(event) {
            //Element
            let tElement = event.target;
            //Styles
            tElement.classList.remove("zoom-in");
            tElement.classList.add("normal-zoom");
            //Zoom
            this.isZoomed = false;
        },
        isVideo(address) {
            return !utils.isNullOrEmpty(address) && address.startsWith('video://');
        },
    }
    // #endregion
});
// #endregion
